/**
 * Islamic special days and events for calendar highlighting
 *
 * Categories:
 *   - friday: every Friday (يوم الجمعة المبارك)
 *   - ayyam_al_beedh: 13, 14, 15 of every Hijri month (recommended fasting)
 *   - major_event: specific Hijri dates with named events (Eid / Occasion)
 *
 * Note: all major events share the same green "Eid / Occasion" color so the
 * legend stays simple. Individual events keep their distinct names.
 */

const EID_COLOR = '#10B981';

// Major Islamic events keyed by "month-day" (Hijri)
export const MAJOR_ISLAMIC_EVENTS = {
  '1-1':   { name_ar: 'رأس السنة الهجرية',     name_en: 'Islamic New Year',         color: EID_COLOR },
  '1-10':  { name_ar: 'يوم عاشوراء',            name_en: 'Day of Ashura',            color: EID_COLOR },
  '3-12':  { name_ar: 'المولد النبوي الشريف',   name_en: 'Mawlid an-Nabi',           color: EID_COLOR },
  '7-27':  { name_ar: 'الإسراء والمعراج',       name_en: "Isra and Mi'raj",          color: EID_COLOR },
  '8-15':  { name_ar: 'ليلة النصف من شعبان',    name_en: "Mid-Sha'ban",              color: EID_COLOR },
  '9-1':   { name_ar: 'بداية شهر رمضان',         name_en: 'Start of Ramadan',         color: EID_COLOR },
  '9-27':  { name_ar: 'ليلة القدر (محتملة)',     name_en: 'Laylat al-Qadr (possible)',color: EID_COLOR },
  '10-1':  { name_ar: 'عيد الفطر المبارك',       name_en: 'Eid al-Fitr',              color: EID_COLOR },
  '12-8':  { name_ar: 'يوم التروية',             name_en: 'Day of Tarwiyah',          color: EID_COLOR },
  '12-9':  { name_ar: 'يوم عرفة',                name_en: 'Day of Arafah',            color: EID_COLOR },
  '12-10': { name_ar: 'عيد الأضحى المبارك',      name_en: 'Eid al-Adha',              color: EID_COLOR },
  '12-11': { name_ar: 'أيام التشريق',            name_en: 'Days of Tashriq',          color: EID_COLOR },
  '12-12': { name_ar: 'أيام التشريق',            name_en: 'Days of Tashriq',          color: EID_COLOR },
  '12-13': { name_ar: 'أيام التشريق',            name_en: 'Days of Tashriq',          color: EID_COLOR },
};

/**
 * Check if a Hijri day is one of the "white days" (13, 14, 15)
 * - recommended fasting days
 */
export const isAyyamAlBeedh = (hijriDay) => {
  return hijriDay === 13 || hijriDay === 14 || hijriDay === 15;
};

/**
 * Get the major event for a specific Hijri date (if any)
 */
export const getMajorEvent = (hijriMonth, hijriDay) => {
  const key = `${hijriMonth}-${hijriDay}`;
  return MAJOR_ISLAMIC_EVENTS[key] || null;
};

/**
 * Check if a gregorian date string represents a Friday
 */
export const isFriday = (gregorianDateStr) => {
  const date = new Date(gregorianDateStr);
  return date.getDay() === 5; // 0=Sun, 5=Fri
};

/**
 * Get all annotations for a calendar cell
 * Returns: { isFriday, isAyyamAlBeedh, event }
 */
export const getDayAnnotations = (hijriMonth, hijriDay, gregorianDateStr) => {
  return {
    isFriday: gregorianDateStr ? isFriday(gregorianDateStr) : false,
    isAyyamAlBeedh: isAyyamAlBeedh(hijriDay),
    event: getMajorEvent(hijriMonth, hijriDay)
  };
};
